import React, {Component} from 'react'
import {Link} from 'react-router'

const Jeyu = {
  banner: {
    background: '#333',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%'
  },
  comingSoon: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 100,
    color: '#444'
  },
  span: {
    display: 'block',
    fontSize: 30
  }
}

export default class NoMatch extends Component {
  render() {
    return(
      <div className="container-fluid">
         <div style={Jeyu.banner}>
          <p style={Jeyu.comingSoon} className="comingSoon">
           404
           <span style={Jeyu.span}>OOPS! Could not find it !</span>
           <Link to="/" style={Jeyu.span}>Back to JeyuTex :) </Link>
          </p>
         </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/View/404.js